import { Card, Col, Row } from "reactstrap";
import { H3, Image, LI, P, UL } from "../../../../AbstractElements";
import { AdminBlog, BlogBy, BlogWithDetailHeading, BlogWithoutDetailHeading, Hits } from "../../../../Constant";
import { BLOG_DATA } from "../../../../Data/Blog";
import { dynamicImage } from "../../../../Service/DynamicImage";

const BlogWithDetails = () => {
  return (
    <Col xl="6" className="set-col-12 box-col-6">
      {BLOG_DATA.map((data, index) => (
        <Card key={index}>
          <Row className="blog-box blog-list">
            <Col sm="5">
              <Image className="img-fluid sm-100-w" src={dynamicImage(`blog/blog-${data.image}.jpg`)} alt="images"/>
            </Col>
            <Col sm="7">
              <div className="blog-details">
                <div className="blog-date">
                  <span>{data.date}</span> January 2018
                </div>
                <H3>{BlogWithoutDetailHeading}</H3>
                <div className="blog-bottom-content">
                  <UL className="blog-social simple-list d-flex flex-row mt-1">
                    <LI className="rounded-0">{BlogBy} {AdminBlog}</LI>
                    <LI className="digits">{data.hits} {Hits}</LI>
                  </UL>
                  <hr />
                  <P className="mt-0">{BlogWithDetailHeading}</P>
                </div>
              </div>
            </Col>
          </Row>
        </Card>
      ))}
    </Col>
  );
};

export default BlogWithDetails;
